// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5899) return "static/chunks/5899-98f06ce36719dfd6.js";
	if (chunkId === 4572) return "static/chunks/4572-2ddb255fb00f43ee.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1144":"fe8d9ffb069e153a","1237":"30e4785e9bc33ab4","3302":"a430fd70051f7f55","3936":"47efb3e169a27d62","8929":"2ebdb86917ceb1b1"}[chunkId] + ".js";
};